module.exports = __webpack_public_path__ + "img/ex4.b53d7f61.png";